if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            setTimeout(function () {
              let drawer__recommendations;
              const enableSwiper = function() {
              drawer__recommendations = new Swiper(".cart-drawer__recommendations .swiper", {
                   slidesPerView: 1.3,
                   spaceBetween: 8,
                   navigation: {
                     nextEl: ".cart-drawer__recommendations .swiper-button-next",
                     prevEl: ".cart-drawer__recommendations .swiper-button-prev",
                   }
                });
              }
              enableSwiper();
              $.getJSON('/cart.js',function(cart){
                const items = [];
                const products = [];
                if(cart.item_count > 0){
                  var last =  cart.items.length - 1;
                  $(cart.items).each(function(i,item){
                    items.push(item.product_id);
                    if(last == i){
                      var length = items.length - 1;
                      $(items).each(function(j,id){
                        fetch(`/recommendations/products?section_id=cart_drawer_recommendantion&product_id=${id}&limit=10&intent=complementary`)
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          $(html).find('#shopify-section-cart_drawer_recommendantion .swiper-slide').each(function(k,product){
                            var data = {handle: $(product).data('handle'),html:product}
                            products.push(data);
                          });
                          setTimeout(function(){
                              if(length == j){
                                const cross_sell = products.filter((a, l) => products.findIndex((s) => a.handle === s.handle) === l);
                                if(cross_sell.length > 0){
                                  drawer__recommendations.destroy(true, true);
                                  $('.cart-drawer__recommendations .swiper .swiper-wrapper').empty();
                                  $(cross_sell).each(function(i,item){
                                    $('.cart-drawer__recommendations .swiper .swiper-wrapper').append(item.html);
                                  });
                                  enableSwiper();
                                }
                              }
                          },200);
                        });
                      });
                    }
                  });
                }
              });
            },1000)
            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
